/**
 * @author Nihar <nihar.baishya@314ecorp.com>
 * @description ViewClaimStatusResponse
 */
import { Link } from 'react-router-dom';

import TypographyWithTooltip from 'components/common/TypographyWithTooltip';
import { getClaimResponsePath } from 'utils/router';

export interface IProps {
	data: ClaimStatusRequests.IResponseModel;
}

const ViewClaimResponse: React.FC<IProps> = ({ data }) => {
	const patientControlNumber = data?.claimMetaData?.patientControlNumber;
	const claimNumber = data?.claimMetaData?.claimNumber;
	const className = patientControlNumber || claimNumber ? undefined : 'text-gray-500';

	const displayText = patientControlNumber || claimNumber || <i>{'No Claim ID'}</i>;
	const claimId = data?.claimId;

	if (!claimId) {
		return displayText;
	}

	return (
		<TypographyWithTooltip
			content={
				<Link className={className} to={getClaimResponsePath(claimId)}>
					{displayText}
				</Link>
			}
		/>
	);
};

export default ViewClaimResponse;
